import { FormattedMessage } from 'react-intl';

interface PeriodTicketKindProps {
  relational: boolean | undefined;
  staticTicketName?: string;
}

export const PeriodTicketKind = ({
  relational,
  staticTicketName,
}: PeriodTicketKindProps) => {
  if (relational) {
    return (
      <span>
        <FormattedMessage defaultMessage="Relationsbunden" />
      </span>
    );
  }
  if (staticTicketName) {
    return (
      <span>
        <FormattedMessage
          defaultMessage="Statisk biljett: {ticket}"
          values={{ ticket: staticTicketName }}
        />
      </span>
    );
  }
  return (
    <span>
      <FormattedMessage defaultMessage="Statisk biljett" />
    </span>
  );
};
